import { romeApi, utils } from "framework";

const state = {
    ready: true,
    cobraPlan: null,
    cobraRates: [],
    rateNote: "Note: Rates MUST be entered without 2%",

    rateYearProps: {
        rateYearId: null,
        planId: null,
        rateType: null,
        startDate: null,
        endDate: null,
    },
    rateValueProps: {
        rateYearId: null,
        rateValueId: null,
        coverageLevel: null,
        individualType: null,
        startAge: null,
        endAge: null,
        numberOfChildren: null,
        rate: null,
    },
    individualTypes: [
        { id: "NUMBEROFCHILDREN", name: "Child", columnNames: ["Number", "Rate"], columns: ["numberOfChildren", "rate"] },
        { id: "CHILDBYAGE", name: "Child", columnNames: ["Age", "Rate"], columns: ["startAge", "rate"] },
        { id: "EMPLOYEE", name: "Employee", columnNames: ["Age", "Rate"], columns: ["startAge", "rate"] },
        { id: "SPOUSE", name: "Spouse", columnNames: ["Age", "Rate"], columns: ["startAge", "rate"] },
        { id: "FEMALE", name: "Female", columnNames: ["Age", "Rate"], columns: ["startAge", "rate"] },
        { id: "MALE", name: "Male", columnNames: ["Age", "Rate"], columns: ["startAge", "rate"] },
        { id: "UNDISCLOSED", name: "Undisclosed", columnNames: ["Age", "Rate"], columns: ["startAge", "rate"] },
    ],
};

const getters = {
    ratesReady: state => {
      return state.ready;
    },
    rateType: (state) => {
        return state.cobraPlan ? state.cobraPlan.rateType : '';
    },
    mostRecentPeriod: (state) => {
        if(!state.cobraRates.length) return null;
        let recent = null;
        state.cobraRates.forEach(x => {
            if(!recent) recent = x;
            if(moment(x.rateYear.startDate).isAfter(recent.rateYear.startDate)) recent = x;
        });
        return recent;
    },
    ratePeriods: (state) => {
        if(!state.cobraRates.length) return [];
        let periods = state.cobraRates.map(x => { return { 
            id: x.rateYear.rateYearId,
            name: moment(x.rateYear.startDate).format("L") + (x.rateYear.endDate ? 
                (' to ' + moment(x.rateYear.endDate).format("L")) : ''),
            startDate: x.rateYear.startDate,
            endDate: x.rateYear.endDate,
        }});
        periods.sort((a,b) => {
            if(a == b) return 0
            else if(moment(a.startDate).isAfter(b.startDate)) return -1;
            else return 1
        });
        return periods;
    },
    pastRatePeriods: (state, getters) => {
        return getters.ratePeriods && getters.mostRecentPeriod && getters.mostRecentPeriod.rateYear ?
            getters.ratePeriods.filter(x => x.id != getters.mostRecentPeriod.rateYear.rateYearId) : getters.ratePeriods;
    },
    getRatesByPeriod: (state) => (rateYearId) => {
        return state.cobraRates.find(x => x.rateYear.rateYearId == rateYearId) || [];
    },
};

function planChanged(planA, planB) {
    return !_.isEqual(planA, planB);
}

const actions = {
    async load({commit, state, rootGetters, rootState}, data) {
        let plan = rootGetters['cobraPlans/getPlan'](data.planId);
        if(planChanged(plan, state.cobraPlan)) data.force = true;
        if(!data.force && (!data.planId || state.cobraPlan && state.cobraPlan.planId == data.planId)) return;

        commit("setReady", false);
        let employerId = rootState.employer.employerId;
        let rates = await romeApi.get(`employer/${employerId}/cobra/plan/${data.planId}/rate`);
        if(rates && rates.length) {
            rates.forEach(y => {
                y.rateValues.forEach(x => { x.rate = Number.parseFloat(x.rate).toFixed(4); });
            });
        }
        // console.log("x-cobraRates load rates: ", rates);

        commit('setPlan', plan);
        commit('setRates', rates);
        commit("setReady", true);
    },
    async save(context, data) {
        data.rateYear.rateYearId = data.rateYear.rateYearId || 0;
        data.rateYear.planId = context.state.cobraPlan.planId;
        data.rateYear.rateType = context.state.cobraPlan.rateType;

        data.rateValues.forEach(x => {
            x.rateYearId = x.rateYearId || 0;
            x.rateValueId = x.rateValueId || 0;
            x.rate = Number.parseFloat(x.rate).toFixed(4);
        })
        // console.log("x-cobraRates save data: ", data, context.state.cobraPlan);

        let employerId = context.rootState.employer.employerId;
        await romeApi.post(`employer/${employerId}/cobra/plan/${context.state.cobraPlan.planId}/rate`, data);
        context.dispatch("load", { planId: context.state.cobraPlan.planId, force: true });
        context.dispatch("cobraPlans/load", { employerId, force: true }, {root:true});
    },
};

const mutations = {
    setReady(state, isReady) {
        // console.log("x-cobra-rate mutation setReady: ", isReady);
        state.ready = isReady;
    },
    setPlan(state, cobraPlan) {
        // console.log("x-cobra-rate mutation setCobraPlan: ", cobraPlan);
        state.cobraPlan = cobraPlan;
    },
    setRates(state, cobraRates) {
        // console.log("x-cobra-rate mutation setCobraRates: ", cobraRates);
        state.cobraRates = cobraRates || [];
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};


// WEBPACK FOOTER //
// ./src/cobra/x-cobra-rates.js